import authReducer from '@store/slices/auth.slice';
import leadsReducer from '@store/slices/leads.slice';
import userReducer from '@store/slices/user.slice';
import benefitsSlice from './benefits.slice';
import dashboardSlice from './dashboard.slice';

export default {
  auth: authReducer,
  user: userReducer,
  dashboard: dashboardSlice,
  leads: leadsReducer,
  benefits: benefitsSlice,
};
